#!/usr/bin/env node
import { foo } from './main'

foo()
